import { FC, FormEvent } from 'react';

import { useForm } from '@inertiajs/react';
import { clsx } from 'clsx';

import { Routes } from '../../models/routes';
import { Button } from '../../components/ui/Button';
import { CardContent, CardFooter } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';

type FormValues = {
    email: string;
};

export const ForgotPasswordForm: FC = () => {
    const { data, setData, post, processing, errors, wasSuccessful } = useForm<FormValues>({
        email: '',
    });

    function submit(e: FormEvent) {
        e.preventDefault();
        post(Routes.Password);
    }

    if (wasSuccessful) {
        return (
            <CardContent>
                <div className="text-center text-sm text-muted-foreground">
                    Якщо ця електронна адреса зареєстрована, ви отримаєте інструкції з відновлення паролю за кілька хвилин.
                </div>
            </CardContent>
        );
    }

    return (
        <form onSubmit={submit}>
            <CardContent className="grid gap-4">
                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        htmlFor="email"
                    >
                        Електронна пошта
                    </label>
                    <Input
                        id="email"
                        type="email"
                        placeholder="m@example.com"
                        autoCapitalize="none"
                        autoComplete="email"
                        autoCorrect="off"
                        className={clsx({
                            'border-red-600': errors.email,
                        })}
                        value={data.email}
                        onChange={(e) => setData('email', e.target.value)}
                    />
                    {errors.email && (
                        <p className="text-sm text-red-600">{errors.email}</p>
                    )}
                </div>
            </CardContent>
            <CardFooter className="flex flex-col pt-2">
                <Button
                    className="h-10 w-full text-sm font-semibold"
                    type="submit"
                    disabled={processing}
                >
                    Надіслати інструкції
                </Button>
            </CardFooter>
        </form>
    );
};
